import React from "react";
import Link from "theme/components/atoms/Typography/Link";
import BodyParagraph from "theme/components/atoms/Typography/Body/BodyParagraph";
import Logo from "theme/components/atoms/Logo";
import SocialMedia from "theme/modules/SocialMedia";
import { FormattedMessage } from "react-intl";

const Brand = () => {
  return (
    <div className="brand">
      <div className="brand__logo">
        <Link to="/">
          <Logo />
        </Link>
      </div>
      <div className="brand__synthesis">
        <BodyParagraph>
          <FormattedMessage
            id="layouts.Footer.Brand.description"
            defaultMessage="Short description of your brand. This improves both your SEO and your user's perception."
          />
        </BodyParagraph>
      </div>
      <div className="brand__social-media">
        <SocialMedia />
      </div>
    </div>
  );
};

export default Brand;
